import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentSupportTab } from '@features/student-page/components/StudentSupportTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students/$studentNo/support')({
    beforeLoad: requireRouteAudience(['staff']),
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Support',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load student support information'>
            <Suspense fallback={<LoadingIndicator resource='support information'/>}>
                <StudentSupportTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
